import { Component, OnInit, Input } from '@angular/core';
import { SearchService } from '../../api';

@Component({
  selector: 'search-count',
  templateUrl: './search-count.component.html',
  styleUrls: ['./search-count.component.css']
})
export class SearchCountComponent implements OnInit {
  @Input() showing: number = 0;
  @Input() total: number = 0;

  constructor(private searchService: SearchService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/search-count/search-count.component.ts